export default {"src":"/_next/static/media/reddit.96690b6d.svg","height":1000,"width":1000,"blurWidth":0,"blurHeight":0};